import React from 'react';
import {Box, Tooltip, Typography} from '@mui/material';
import { styled } from '@mui/system';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DirectionsIcon from '@mui/icons-material/Directions';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import {getDayName, getEventTimeString, getMonthName, orange} from "../utils";

const DetailsBox = styled(Box)(() => ({
    // borderRight: "1px solid rgba(0, 0, 0,0.2)",
    marginTop: "10px !important",
    marginBottom: "10px !important",
    paddingTop:"10px"
}));

const DetailItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1), // Space between items
    color: '#757575', // Gray color for text and icons
}));

const DetailText = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(1),
    component: 'a',
    textAlign: 'left',
    color: 'black',
}));

const getMonth = (eventDate) => {
    const date = new Date(eventDate);
    const month = getMonthName(date.getMonth());
    return (month)
}

const InfoBox = ({event, showLocation, isToday}) => {
    const handleAddressClick = React.useCallback(() => {
        if (!event.location.cords?.length) return;
        showLocation(event.location);
    }, [event.location, showLocation]);

    return (
        <DetailsBox>
            {event.endDate && (
                <Typography
                    variant="h6"
                    component="h4"
                    style={{
                        fontWeight: '600',
                        fontSize: "1rem",
                        color: "#303969",
                        fontFamily: "inherit",
                        letterSpacing: "0.06rem",
                        justifySelf: "flex-start",
                    }}
                >
                    {/* {`${getDayName(event.startDate.getDay())}, ${event.startDate.getDate()} ${getMonth(event.startDate)} `}
                    to {`${getDayName(event.date.getDay())}, ${event.date.getDate()} ${getMonth(event.date)} `} */}
                </Typography>
            )}
            <DetailItem>
                <DirectionsIcon sx={{color: isToday ? orange[700]: "black", verticalAlign: "flex-end", fontSize: "20px", alignSelf: "baseline"}} />
                {event.location.cords.length ? (
                    <Tooltip title="Get Directions" placement="top">
                        <DetailText
                            variant="body2"
                            style={{color: "#005dff", cursor: "pointer"}}
                            onClick={handleAddressClick}
                        >
                            {event.location.address}
                        </DetailText>
                    </Tooltip>
                ): (
                    <DetailText
                        variant="body2"
                        onClick={handleAddressClick}
                    >
                        {event.location.address}
                    </DetailText>
                )}
            </DetailItem>
            <DetailItem>
                <AccessTimeIcon sx={{color: isToday ? orange[700]: "black", fontSize: "16px",alignSelf: "baseline", marginTop: "2px" }} />
                <DetailText variant="body2">{getEventTimeString(event)}</DetailText>
            </DetailItem>
            {event.location.phone ? (
                <DetailItem>
                    <LocalPhoneIcon sx={{color: isToday ? orange[700]: "black", fontSize: "16px", alignSelf: "baseline", marginTop: "2px" }} />
                    <DetailText variant="body2">
                        {event.location.phone.split(",").map((n, i) => (
                            <span key={n}>{i>0? ",": ""}{n}</span>
                        ))}
                    </DetailText>
                </DetailItem>
            ): ""}

        </DetailsBox>
    );
};

export default InfoBox;